import React from "react";
import './sign-up.style.scss'

import { auth, createUserProfileDocument } from "../../firebase/firebase.utils";
import Button from "../button/button.component";
import FormInput from "../form-input/form-input.component";

class SignUp extends React.Component {
  constructor() {
    super(); 

    this.state = {
      displayName: '', 
      email: '', 
      password: '', 
      confirmPassword: ''
    }
  }
  
  handleSubmit = async event => {
    event.preventDefault()
    
    const { displayName, email, password, confirmPassword } = this.state; 
    
    if (password !== confirmPassword) {
      alert("Passwords don't match"); 
      return;
    }
    
    try {
      const { user } = await auth.createUserWithEmailAndPassword( email, password ); 
      
      await createUserProfileDocument(user, { displayName }); 
      this.setState({
        displayName: '', 
        email: '', 
        password: '', 
        confirmPassword: ''
      })
    } catch (error) {
      console.log('Error: \n', error)
    }
  }; 

  handleChange = event => {
    const { name, value } = event.target; 
    this.setState({ [name]: value })
  }

  render() {
    const { displayName, email, password, confirmPassword } = this.state; 

    return (
      <div className="sign-up">
        <h2 className="title mt-4 mb-3 fw-semibold">I do not have an account</h2>
        <span>Sign up with your email and password</span>
        <form className="sign-up-form" onSubmit={this.handleSubmit}>
          <FormInput 
            type='text'
            name='displayName'
            value={ displayName }
            onChange={this.handleChange}
            label='Display Name'
            required
          />
          <FormInput 
            type='email'
            name='email'
            autoComplete='username'
            value={ email }
            onChange={this.handleChange}
            label='Email'
            required
          />
          <FormInput 
            type='password'
            name='password'
            autoComplete='current-password'
            value={ password }
            onChange={this.handleChange}
            label='Password'
            required
          />
          <FormInput 
            type='password'
            name='confirmPassword'
            autoComplete='current-password'
            value={ confirmPassword }
            onChange={this.handleChange}
            label='Confirm Password'
            required
          />
          <Button type='submit'>SIGN UP</Button>
        </form>
      </div>
    );
  }
}

export default SignUp
